
import React from 'react'
import { withRouter, Route, Redirect } from 'react-router-dom'
import { compose } from 'recompose'
import AmenityServiceRoutePermission from './AmenityServiceRoutePermission'

class PublicAmenityServiceRoute extends AmenityServiceRoutePermission {

    render() {
        let pathCurrent = this.getPathCurrent()
        if (this.isAuthenticated() && pathCurrent === "/amenityservice/login") {
            return <Redirect to={`/amenityservice`} />
        }
        let data = this.getComponentRoute()
        return <Route {...data.props} path={data.path} component={data.Component} />
    }
}

PublicAmenityServiceRoute.defaultProps = {
    component: null,
    path: "",
}

const enhance = compose(
    withRouter,
)

export default enhance(PublicAmenityServiceRoute)


// WEBPACK FOOTER //
// ./src/policy/PublicAmenityServiceRoute.js